import * as React from "react";
import Api from "./Api";
import CheckCtl from "./input/CheckCtl";
import DateCtl from "./input/DateCtl";
import LabelCtl from "./input/LabelCtl";
import LookupCtl from "./input/LookupCtl";
import SelectCtl from "./input/SelectCtl";
import TextCtl from "./input/TextCtl";
import { Guid } from "@testout/testout-commerce/core/Guid";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import { TempProvisionCampus } from "@testout/testout-commerce/models/commerce/TempProvisionCampus";
import "./TempProvisionCtl.scss";
import "./App.scss";

interface ITempProvisionProps {
    expireDate?: Date;
    campuses: TempProvisionCampus[];
    sendEmail: boolean;
    fromEmployeeNumber: string;
    emailAddresses: string;
    emailTemplateId: string;
    employeeEmails: ListItem[];
    onChange: (campuses: TempProvisionCampus[], sendEmail: boolean, emailTemplateId: string,
               emailAddresses: string, fromEmployeeNumber: string, expireDate?: Date) => void;
    onSubmit: () => void;
    onCancel: () => void;
    errorMessage: string;
}

interface ITempProvisionState {
    inProgress: boolean;
}

export default class TempProvisionCtl extends React.PureComponent<ITempProvisionProps, ITempProvisionState> {

    constructor(props: ITempProvisionProps) {
        super(props);

        this.state = { inProgress: false };
    }

    _mailTemplates: ListItem[] = [
        { name: 'Default email template', value: 'TempProvisionLicenses' }
        //{ name: 'Secondary template', value: '' }
    ];

    // Someday the _mailTemplates will be replaced with something like this in the calling control:
    //    async componentDidMount() {
    //        let templates = await Api.get<ListItem[]>(`/api/templates/list`) ?? new Array<ListItem>();
    //        this.setState({ templates: templates });
    //    }

    onDateChange = (value?: Date) => {
        if (value)
            this.props.onChange(this.props.campuses, this.props.sendEmail, this.props.emailTemplateId,
                                this.props.emailAddresses, this.props.fromEmployeeNumber, value);
    }

    onCampusChange = (campus: TempProvisionCampus, value?: string) => {
        if (!value)
            return;
        var findCampus = this.props.campuses.filter(c => c.customerNumber === campus.customerNumber);
        if (findCampus.length > 0) {
            findCampus[0].labSimCampusId = new Guid(value);
            this.props.onChange(this.props.campuses, this.props.sendEmail, this.props.emailTemplateId,
                this.props.emailAddresses, this.props.fromEmployeeNumber, this.props.expireDate);
        }
    }

    onDoCampusSearch = async (value: string, exact?: boolean): Promise<ListItem[]> => {
        return exact
            ? [await Api.get<ListItem>(`/api/campuses/${value}/list-item`)]
            : await Api.get<ListItem[]>(`/api/campuses/list-items?search=${value}`);
    }

    isNew = (campus: TempProvisionCampus, value: boolean) => {
        var findCampus = this.props.campuses.filter(c => c.customerNumber === campus.customerNumber);
        if (findCampus.length > 0) {
            findCampus[0].createNewCampus = value;
            this.props.onChange(this.props.campuses, this.props.sendEmail, this.props.emailTemplateId,
                                this.props.emailAddresses, this.props.fromEmployeeNumber, this.props.expireDate);
        }
    }

    onCampusNameChange = (campus: TempProvisionCampus, value: string) => {
        var findCampus = this.props.campuses.filter(c => c.customerNumber === campus.customerNumber);
        if (findCampus.length > 0) {
            findCampus[0].newCampusName = value;
            this.props.onChange(this.props.campuses, this.props.sendEmail, this.props.emailTemplateId,
                this.props.emailAddresses, this.props.fromEmployeeNumber, this.props.expireDate);
        }
    }

    onSendEmailChange = (value: boolean) => {
        this.props.onChange(this.props.campuses, value, this.props.emailTemplateId,
                           this.props.emailAddresses, this.props.fromEmployeeNumber, this.props.expireDate);
    }

    onEmailTemplateChange = (value: string) => {
        this.props.onChange(this.props.campuses, this.props.sendEmail, value,
                            this.props.emailAddresses, this.props.fromEmployeeNumber, this.props.expireDate);
    }

    onEmailAddressesChange = (value: string) => {
        // Switch any semi-colons to commas
        value = value.replace(';', ',');
        this.props.onChange(this.props.campuses, this.props.sendEmail, this.props.emailTemplateId,
                            value, this.props.fromEmployeeNumber, this.props.expireDate);
    }

    fromEmailChange = (value: string) => {
        this.props.onChange(this.props.campuses, this.props.sendEmail, this.props.emailTemplateId,
                            this.props.emailAddresses, value, this.props.expireDate);
    }

    onSubmit = () => {
        this.setState({ inProgress: true });
        this.props.onSubmit();
    }

    // Determine if all of the campuses have been correctly selected
    campusesSelected = (): boolean => {
        for (var campus of this.props.campuses) {
            if (!campus.labSimCampusId && !campus.createNewCampus) {
                return false;
            }
        }
        return true;
    }


    render() {
        return <div className="modalScreenBackground">
            <div className="tempModalDialog">
                <div className="modalHeader">
                    <LabelCtl className="modalHeaderTitle" label="Provision Temporary Licenses" />
                    <button className="link" onClick={() => this.props.onCancel()}>
                        <div className="modalCloseButton">
                            <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.5,1.5l-13,13m0-13,13,13" transform="translate(-1 -1)" stroke="#ffffff" strokeWidth="3" />
                            </svg>
                        </div>
                    </button>
                </div>
                <div className="scrollableDiv">
                    {this.props.errorMessage !== "" && <p className="error">{this.props.errorMessage}</p>}
                    <div className="description">A temporary LabSim license for will be created for every school that is part of the quote. An introductory email using the
                        selected email template will optionally be created and sent to the entered addresses.</div>
                    <LabelCtl label="License expiration date:">
                        <DateCtl value={this.props.expireDate} onChange={this.onDateChange} />
                    </LabelCtl>
                    {this.props.campuses.map((campus: TempProvisionCampus, index: number) => <div className="rbLineDiv">
                        <LabelCtl className="rbLine" label={`${campus.customerName} LabSim campus:`}>
                            <div className="rbLabel">
                                <div className="radiobuttonGroup">
                                    <input name={index.toString()} className="rb" type="radio" onClick={() => this.isNew(campus, false)} checked={!campus.createNewCampus} />
                                    <LabelCtl className="rbLabel" label="Use:">
                                        <LookupCtl placeholder="Search for a campus" hideItemValue={true} className="rbLookup"
                                                   value={campus.labSimCampusId ? campus.labSimCampusId.toString() : ""}
                                                   onChange={() => this.onCampusChange(campus)} onSearch={this.onDoCampusSearch} disabled={campus.createNewCampus} />
                                    </LabelCtl>
                                </div>
                                <div className="radiobuttonGroup">
                                    <input name={index.toString()} className="rb" type="radio" onClick={() => this.isNew(campus, true)} checked={campus.createNewCampus} />
                                    <LabelCtl className="rbLabel" label="Create new:">
                                        <TextCtl value={campus.newCampusName} onChange={(value) => this.onCampusNameChange(campus, value)} disabled={!campus.createNewCampus} />
                                    </LabelCtl>
                                </div>
                            </div>
                        </LabelCtl>
                    </div>)}
                    <div className="sendEmail">
                        <CheckCtl className="cbSendEmail" label="Send email" value={this.props.sendEmail} onChange={this.onSendEmailChange} disabled={false} />
                        <table className="emailTable">
                            <tr>
                                <td><LabelCtl label="From:" /></td>
                                <td><SelectCtl items={this.props.employeeEmails} value={this.props.fromEmployeeNumber} disabled={!this.props.sendEmail}
                                               onChange={this.fromEmailChange} hideItemValue={true} /></td>
                            </tr>
                            <tr>
                                <td><LabelCtl label="To:" /></td>
                                <td><TextCtl value={this.props.emailAddresses} onChange={this.onEmailAddressesChange} disabled={!this.props.sendEmail} 
                                             hintText="Separate each email address with a comma" /></td>
                            </tr>
                            <tr>
                                <td><LabelCtl label="Email template:" /></td>
                                <td><SelectCtl value={this.props.emailTemplateId.toString()} onChange={this.onEmailTemplateChange} hideItemValue={true}
                                           items={this._mailTemplates} disabled={!this.props.sendEmail} /></td>
                            </tr>
                        </table>
                    </div>
                    <div className="modalBottomButtons">
                        <button className="secondary" onClick={() => this.props.onCancel()}>Cancel</button>
                        <button className="primary" onClick={() => this.onSubmit()}
                                disabled={this.state.inProgress || !this.campusesSelected() ||
                                (this.props.emailAddresses === '' && this.props.sendEmail)}>Provision Licenses</button>
                    </div>
                </div>
            </div>
        </div>;
    }
}
